// Screens tracked by BOTH apps (sent as a `screen_view` event with the value
// as the `screen` property). Platform-specific screens live in
// mobile-page-events.ts / web-page-events.ts.
export enum PageEvents {
  Login = 'log_in',
  Today = 'today',
  TodayCalendar = 'today_calendar',
  Inbox = 'inbox',
  Upcoming = 'upcoming',
  AllTasks = 'allTasks',
  Habits = 'habits',
  LifeAreas = 'lifeAreas',
  LifeAreaDetailVision = 'life_area_detail_vision',
  LifeAreaDetailGoals = 'life_area_detail_goals',
  LifeAreaDetailTasks = 'life_area_detail_tasks',
  GoalsList = 'goals-list',
  GoalsTimeline = 'goals-timeline',
  GoalsDetail = 'goalDetail',
  GoalEdit = 'goalWizard',
  TagDetail = 'tagDetail',
  SearchDialog = 'search_dialog',
  Completed = 'completed',
}
